<h1 id="hero-title" class="hero-title" *ngIf="title">{{ title }}</h1>
<h2 id="hero-copy" class="hero-copy" *ngIf="leadText">
  {{ leadText }}
</h2>
<nibtravel-picture
  class="hero-picture"
  [imageMobile]="imageMobile"
  [imageLowResolution]="imageLowResolution"
  [imageHighResolution]="imageHighResolution"
>
</nibtravel-picture>
<ng-content></ng-content>
